export default "__VITE_PUBLIC_ASSET__f6af7caf__"